export default __webpack_public_path__ + "static/media/clean-search.d6eb3f0a.svg";